var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObj,style:({'width': _vm.width, 'height': _vm.height}),attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading....")])])}
var staticRenderFns = []

export { render, staticRenderFns }